import { Button, Classes, Dialog } from "@blueprintjs/core";
import React from "react";
import { GlobalStateContext } from "../../Context";
import { UserLanguage } from "../../lang/lang";
import { DialogBody, DialogFooter } from "../dialog/Dialog";
import { FlexGrow, FlexRowStretch } from "../flex/Flex";
import { InputFormMode } from "./InputForm";
import {
  update_form_state,
  InputFormBuilder,
  InputFormBuilderProperties,
} from "./InputFormBuilder";

export interface InputModalBuilderProps<
  ObjectType,
  MutationResponse,
  MutationVariable = any
> extends InputFormBuilderProperties<
    ObjectType,
    MutationResponse,
    MutationVariable
  > {
  open: boolean;
  // title: string;
  onClose: () => void;
  resetOnClose?: boolean;
}

export class InputModalBuilder<
  ObjectType = any,
  MutationResponse = any,
  MutationVariable = any
> extends React.PureComponent<
  InputModalBuilderProps<ObjectType, MutationResponse, MutationVariable>
> {
  private onClose = () => {
    if (this.props.resetOnClose) this.setState(update_form_state(this.props));
    this.props.onClose();
  };

  render() {
    return (
      <GlobalStateContext.Consumer>
        {(global_state) => (
          <InputFormBuilder<ObjectType, MutationResponse, MutationVariable>
            {...this.props}
          >
            {(builder) => {
              return (
                <Dialog
                  isOpen={this.props.open}
                  title={
                    this.props.mode === InputFormMode.Create
                      ? this.props.texts.create.title
                      : this.props.texts.update.title
                  }
                  onClose={() => this.onClose()}
                  canEscapeKeyClose={false}
                  canOutsideClickClose={false}
                  className={
                    global_state.dark_mode
                      ? [Classes.DARK, this.props.className].join(" ")
                      : this.props.className
                  }
                >
                  <DialogBody>{this.props.children(builder)}</DialogBody>
                  <DialogFooter>
                    <FlexRowStretch>
                      <Button
                        disabled={builder.submitting}
                        onClick={() => this.onClose()}
                        style={{ float: "left" }}
                      >
                        {UserLanguage().actions.cancel}
                      </Button>
                      <FlexGrow />
                      {builder.buildSubmitButton()}
                    </FlexRowStretch>
                  </DialogFooter>
                </Dialog>
              );
            }}
          </InputFormBuilder>
        )}
      </GlobalStateContext.Consumer>
    );
  }
}

// export class InputModalBuilder<
//   ObjectType = any,
//   MutationResponse = any,
//   MutationVariable = any
// > extends React.PureComponent<
//   InputModalBuilderProps<ObjectType, MutationResponse, MutationVariable>,
//   InputFormState<ObjectType>
// > {
//   state = build_initial_state(this.props); // this.getInitialState(); // dirty hack xd

//   public componentDidUpdate(
//     prevProps: Readonly<
//       InputModalBuilderProps<ObjectType, MutationResponse, MutationVariable>
//     >
//   ) {
//     if (isDifferent(this.props, prevProps)) {
//       console.log("got new props");
//       this.setState(build_initial_state(this.props));
//     }
//   }

//   private onSubmit = () => {
//     this.setState({ submitting: true });

//     // fix values

//     let values = ConvertInputForSubmit(this.props.keys, this.state.values);

//     console.log("values after convert", values);

//     if (this.props.beforeMutate) {
//       values = this.props.beforeMutate(values);
//       console.log("values after beforeMutate", values);
//     }

//     values = reformId<Partial<ObjectType>, Partial<ObjectType>>(
//       _.pickBy(values, _.identity) as Partial<ObjectType>,
//       this.props.reformId || []
//     );

//     console.log("values after reform", values);

//     values = jsonStringify<Partial<ObjectType>, Partial<MutationVariable>>(
//       _.pickBy(values, _.identity) as Partial<ObjectType>,
//       this.props.stringyfy || []
//     );

//     console.log("values after stringify", values);

//     const data: ValuesVariables<MutationVariable> = {
//       values,
//     };

//     console.log("mutation variables", data);

//     this.props
//       .mutation({ variables: data })
//       .then((v) => {
//         this.setState({ success: true });
//         console.log("success?", v);
//         setTimeout(() => {
//           this.setState(build_initial_state(this.props));
//           this.props.onSuccess();
//         }, 1000);
//       })
//       .catch((e) => {
//         console.log("error", e);
//         this.setState({ success: false, error: parseError(e) });
//         setTimeout(() => this.setState({ submitting: false }), 500);
//       });
//   };

//   update_state(new_state: InputFormState<ObjectType>) {
//     this.setState(
//       this.props.onStateChange
//         ? this.props.onStateChange(
//             new_state,
//             this.state,
//             (k) => _.get(new_state.values, k) !== _.get(this.state.values, k)
//           )
//         : new_state
//     );
//   }

//   render = () => {
//     const buildCards = () =>
//       InputCardBuilder({
//         keys: this.props.keys,
//         setState: (s) => this.update_state(s),
//         state: this.state,
//         successText: this.props.successText,
//       });

//     const buildField = (field: keyof ObjectType) => {
//       let data = _.get(this.props.keys, field);
//       if (data) {
//         return InputBuilderSingle({
//           data,
//           index: field.toString(),
//           setState: (s) => this.update_state(s),
//           state: this.state,
//         });
//       }
//       return <></>;
//     };

//     let nodes = this.props.children({
//       buildCards,
//       buildField,
//       submitting: this.state.submitting,
//     });

//     return (
//       <GlobalStateContext.Consumer>
//         {(global_state) => (
//           <Dialog
//             isOpen={this.props.open}
//             title={this.props.title}
//             onClose={() => this.onClose()}
//             canEscapeKeyClose={false}
//             canOutsideClickClose={false}
//             className={
//               global_state.dark_mode
//                 ? [Classes.DARK, this.props.className].join(" ")
//                 : this.props.className
//             }
//           >
//             <DialogBody>{nodes}</DialogBody>
//             <DialogFooter>
//               <FlexRowStretch>
//                 <Button
//                   disabled={this.state.submitting}
//                   onClick={() => this.onClose()}
//                   style={{ float: "left" }}
//                 >
//                   {UserLanguage().actions.cancel}
//                 </Button>
//                 <FlexGrow />
//                 <Button
//                   disabled={this.state.submitting}
//                   intent={Intent.PRIMARY}
//                   onClick={() => this.onSubmit()}
//                   icon={
//                     this.props.mode === InputFormMode.Create ? "plus" : "edit"
//                   }
//                 >
//                   {this.props.mode === InputFormMode.Create
//                     ? UserLanguage().actions.create
//                     : UserLanguage().actions.edit}
//                 </Button>
//               </FlexRowStretch>
//             </DialogFooter>
//           </Dialog>
//         )}
//       </GlobalStateContext.Consumer>
//     );
//   };
// }
